import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { AuthenService } from '../../../services/Authen/authen.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-page-management',
  templateUrl: './page-management.component.html',
  styleUrls: ['./page-management.component.scss']
})
export class PageManagementComponent implements OnInit {

  constructor(
    private router: Router,
    private SpinnerService: NgxSpinnerService,
    private AuthenService: AuthenService
  ) { }

  role:any;
  auth_data: any;
  role_data: any;
  open_ = false;

  ngOnInit(): void {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
  }

  onChange(index) {
    // this.SpinnerService.show();
    if (this.role_data[index]['status'] == false) { //open
      this.role_data[index]['status'] = true
    } else if (this.role_data[index]['status'] == true) { //close
      this.role_data[index]['status'] = false
    }
    // this.SpinnerService.hide();
  }

  submit(){
    let post_data = []
    for (let i = 0; i < this.role_data.length; i++) {
      if (this.role_data[i]['status'] == true) {
        this.role_data[i]['status'] = 'y';
      } else {
        this.role_data[i]['status'] = 'n';
      }

      post_data.push(
        {
          menu: this.role_data[i]['menu'],
          role: this.role_data[i]['role'],
          status: this.role_data[i]['status']
        }
      );
    }

    this.AuthenService.Add_edit_manage_role(post_data, this.role).subscribe(
      responce => {
        this.get_manage_role(this.role);
        Swal.fire({
          icon: 'success',
          title: 'แก้ไขข้อมูลเสร็จสิ้น',
          showConfirmButton: false,
          timer: 1500
        });
      }
    );
  }

  get_manage_role(role) {
    this.role = role;
    this.open_ = true;
    this.AuthenService.Get_manage_role(role).subscribe(
      responce => {
        this.role_data = responce;
        for (let i = 0; i < responce.length; i++) {
          if (responce[i]['status'] == 'y') {
            this.role_data[i]['status'] = true;
          } else {
            this.role_data[i]['status'] = false;
          }
        }
      }
    );
  }

}
